"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagCard = void 0;
var core_api_1 = require("@ikegps/core-api");
var autocomplete_menu_1 = require("../../components/autocomplete.menu/autocomplete.menu");
var image_button_1 = require("../../components/button/image.button");
var icons_1 = require("../../components/icon/icons");
var spinner_1 = require("../../components/spinner/spinner");
var theme_1 = require("../../components/theme");
var dom_1 = require("../../dom");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var page_state_1 = require("../../state/page.state");
var store_1 = require("../../store");
var photomeasure_button_1 = require("../photomeasure.button/photomeasure.button");
var tag_card_checkbox_1 = require("../tag.card.checkbox/tag.card.checkbox");
var bounding_string_1 = require("../tag.map/bounding.string");
var tag_name_input_1 = require("../tag.name.input/tag.name.input");
var tag_name_input_ctrl_1 = require("../tag.name.input/tag.name.input.ctrl");
var topological_editor_button_1 = require("../topological.editor.button/topological.editor.button");
var tag_card_style_1 = require("./tag.card.style");
(0, theme_1.addStyles)(tag_card_style_1.Style);
var TagCard = /** @class */ (function () {
    function TagCard(state, tag) {
        var _this = this;
        this.autoCompleteMenu = null;
        this.state = state;
        this.tag = tag;
        this.ctrl = new tag_name_input_ctrl_1.TagNameInputController(this.state, tag);
        this.autoCompleteMenu = new autocomplete_menu_1.AutoCompleteMenu({
            inputState: this.ctrl.getInputState(),
            options: function () { return _this.ctrl.autoCompleteOptions; },
            onselect: function (option) { return _this.ctrl.updateEdit(option.value); }
        });
    }
    TagCard.prototype.view = function () {
        var _a;
        var _this = this;
        var isHovered = page_state_1.CurrentState.hoverId === this.tag.objectId;
        var className = "".concat(tag_card_style_1.CSS.container, " ").concat(isHovered ? tag_card_style_1.CSS.isHovered : '');
        var summary = store_1.AppStore.TagSummary.get(this.tag.objectId);
        var hasSummary = summary != null;
        var editing = this.state.edit.isEditingTag(this.tag.objectId);
        var renaming = this.state.edit.isRenamingTag(this.tag.objectId);
        var showEditButtons = !this.state.edit.isEditingTag() && !this.state.edit.isRenamingTag() && !page_state_1.CurrentState.CollectionEdit.isDirty;
        var toolbar = this.makeToolbar();
        var collectionsSelected = page_state_1.CurrentState.Tag.collectionsSelectedSize(this.tag.objectId);
        var selectedState = {
            isSelected: function () { return collectionsSelected === summary.revisions.length; },
            setSelected: function (selected) { return page_state_1.CurrentState.Tag.selectTag(_this.tag.objectId, selected); },
            isIndeterminate: function () { return collectionsSelected > 0 && collectionsSelected < summary.revisions.length; }
        };
        var children = [
            hasSummary ? tag_card_checkbox_1.TagCardCheckbox.view(this.state, selectedState, this.tag, summary) : null,
            editing ? tag_name_input_1.TagNameInput.view(this.ctrl, this.autoCompleteMenu) : tag_name_input_1.TagNameReadonlyInput.view(this.ctrl),
            renaming ? spinner_1.Spinner.view() : null,
            showEditButtons ? toolbar : null
        ];
        return (0, mithril_1.m)('div', (_a = {
                className: className,
                key: this.tag.objectId
            },
            _a[dom_1.DRAGON_ID] = this.tag.objectId,
            _a[dom_1.DRAGON_TYPE] = dom_1.DragonDomTypes.TAG,
            _a), children);
    };
    TagCard.prototype.makeToolbar = function () {
        var _this = this;
        var _a;
        var canEdit = services_1.Services.Token.has(core_api_1.IkeToken.TAG_JOB_UPDATE);
        var tagCenterObj = (_a = store_1.AppStore.TagSummary.get(this.tag.objectId)) === null || _a === void 0 ? void 0 : _a.center;
        if (!tagCenterObj) {
            return null;
        }
        var tagCenterString = bounding_string_1.BoundingString.toString(tagCenterObj, 15);
        var children = [
            (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_MAP_MODE) &&
                !services_1.Services.UserProfile.isReadOnly(services_1.Services.UserProfile.get(services_1.Services.User.current.objectId))) && (topological_editor_button_1.TopologicalEditorButton.view(this.tag.objectId, tagCenterString)),
            photomeasure_button_1.PhotomeasureButton.view(this.tag.objectId),
            canEdit && (image_button_1.ImageButton.view(icons_1.MaterialIcon.EDIT, {
                title: i18n_1.T.LINK_EDIT_TAG,
                className: tag_card_style_1.CSS.renamejob,
                onclick: function () { return _this.state.edit.editTag(_this.tag.objectId, _this.tag.name); }
            }))
        ];
        return (0, mithril_1.m)('div', { className: tag_card_style_1.CSS.toolbar }, children);
    };
    return TagCard;
}());
exports.TagCard = TagCard;
//# sourceMappingURL=tag.card.js.map